export default "__VITE_ASSET__BqwGyU6W__"